import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, MapPin, FileText } from "lucide-react";

// Simple contact page — does not collect any data itself, just exposes
// the controller's contact details. A real contact form would need its
// own GDPR consent so we keep it static for now.
export default function Contact() {
  return (
    <div className="min-h-screen bg-[#09090B] text-white">
      <div className="max-w-2xl mx-auto px-6 py-10">
        <Link to="/" data-testid="contact-back" className="inline-flex items-center gap-2 text-zinc-500 hover:text-white mb-8 font-mono text-xs uppercase tracking-widest">
          <ArrowLeft className="w-4 h-4" /> Home
        </Link>
        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#FF4400] mb-3">· Contatti</div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-3">Parliamone.</h1>
        <p className="text-zinc-400 font-body mb-10">
          Per richieste di supporto, privacy, fatturazione o domande commerciali.
        </p>

        <div className="space-y-4">
          <div className="bg-zinc-900/60 border border-zinc-800 rounded-sm p-5 flex items-start gap-4">
            <Mail className="w-5 h-5 text-[#FF4400] mt-0.5 shrink-0" />
            <div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mb-1">Email</div>
              <a href="mailto:info@homereel.it" className="font-display font-bold text-lg text-white hover:text-[#FF4400] transition-colors" data-testid="contact-email">
                info@homereel.it
              </a>
              <div className="text-[12px] text-zinc-500 mt-1 font-body">Risposta entro 48 ore lavorative</div>
            </div>
          </div>

          <div className="bg-zinc-900/60 border border-zinc-800 rounded-sm p-5 flex items-start gap-4">
            <MapPin className="w-5 h-5 text-[#FF4400] mt-0.5 shrink-0" />
            <div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mb-1">Titolare</div>
              <div className="font-display font-bold text-white">Marco Marangoni</div>
              <div className="text-[13px] text-zinc-400 font-body mt-1">
                P.IVA 04018220964
                <br />
                Piazza della Costituzione 12 — 20068 Peschiera Borromeo (MI)
              </div>
            </div>
          </div>

          <div className="bg-zinc-900/60 border border-zinc-800 rounded-sm p-5 flex items-start gap-4">
            <FileText className="w-5 h-5 text-[#FF4400] mt-0.5 shrink-0" />
            <div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mb-1">Documenti legali</div>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-[14px] font-body">
                <Link to="/privacy" className="text-[#FF4400] hover:text-[#FF6633]">Privacy Policy</Link>
                <Link to="/cookie-policy" className="text-[#FF4400] hover:text-[#FF6633]">Cookie Policy</Link>
                <Link to="/terms" className="text-[#FF4400] hover:text-[#FF6633]">Termini di Servizio</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
